export default {
    message: {
        tiers: {
            t1: {
                label: "Отдельный продукт",
                desc: "<p>Унифицированный доступ ко всем виртуальным, веб- и SaaS-приложениям и защита пользователей, приложений и данных с помощью сквозных контекстуальных средств безопасности.</p><p>Обеспечивает функциональность прокси-сервера без VPN и поддержку технологии единого входа для веб-, SaaS-, виртуальных и мобильных приложений, а также защиту от вредоносного контента, клавиатурных шпионов и вредоносного ПО для захвата экрана.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Комплексное решение для рабочих мест, предназначенное для тех, кому необходимо полнофункциональное цифровое рабочее место с детальным контролем безопасности, но не требуются виртуальные приложения и десктопы.</p><p>Включает функционал Workspace Standard, а также дополнительные средства контроля безопасности для SaaS- и веб-приложений, систему унифицированного управления конечными устройствами и Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Комплексное решение для рабочих мест, включающее варианты развертывания в гибридных средах для Citrix Virtual Apps and Desktops.</p><p>Содержит функционал Workspace Premium, а также возможность управления облачными развертываниями для Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}